import React, { useState, useEffect, useContext, useRef } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";

import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";
import Dialogo from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import BuscarClientes from "../../reductores/acciones/dispatch/BuscarClientes";
// import VentanaClienteAFacturar from "../../reductores/ventanas/VentanaClienteAFacturar";

const DialogoSeleccionarClienteLayout = ({
    ventana,
    dispatchQ,
    estadoQ,
    buscarClientesCommand,

    // buscarUnSoloClienteAFacturar,
}) => {
    const {
        // dispatchPrincipal,
        // estadoPrin,
        // posicionarVentanaTop,
        eliminarVentana,
        // seleccionarCliente
        // crearYMostrarVentana,
        // getVentanaIdenticaSiYaExisteEnLalista,
    } = useContext(GlobalContext);

    // const isMounted = useRef(false);

    useEffect(() => {
        if (!estadoQ.flag.procesandoComando) {
            return;
        }
        buscarClientesCommand.ejecutar();
         
        return () => {
                buscarClientesCommand.cancelar();
        };
        // } else {
            // isMounted.current = true;
        // }
    }, [estadoQ.flag.procesandoComando]);

    /* const cancelarClick = (eventoDom) => {
        dispatchPrincipal(new EliminarVentana(ventana));
        eventoDom.stopPropagation();
    }; */

    const dobleClickEnFila = (eventoSyn) => {
        eliminarVentana(ventana);
        ventana.notificarClienteSeleccionado({id:eventoSyn.data.idCliente});
        /* const nuevaVentana = new VentanaClienteAFacturar();
        nuevaVentana.estadoComp.flag.modoOperacion = ModosOp.OK;
        nuevaVentana.estadoComp.domain.screen.idCliente = eventoSyn.data.idCliente;
        const ventanaAAbrir = getVentanaIdenticaSiYaExisteEnLalista(nuevaVentana);
        // const ventanaAAbrir = MostrarVentana.getVentanaExistenteEnLaLista(estadoPrin, nuevaVentana);
        if (ventanaAAbrir) {
            // ventanaAAbrir.estadoCom.flag.modal = true;
            ventana.ventanaCargando = ventanaAAbrir;
            // dispatchQ(new BuscarUnSoloClienteAFacturar());
            posicionarVentanaTop(ventanaAAbrir);
            // dispatchPrincipal(new PosicionarVentanaTop(ventanaAAbrir));
            // buscarUnSoloClienteAFacturar(ventanaAAbrir.idCliente);
            return;
        }
        nuevaVentana.estadoComp.flag.modal = true;
        nuevaVentana.estadoComp.flag.cargandoEntidad = true;
        ventana.ventanaCargando = nuevaVentana;
        cargarYMostrarVentana(nuevaVentana); */
        // dispatchPrincipal(new CargarYMostrarVentana(nuevaVentana));
        // buscarUnSoloClienteAFacturar(nuevaVentana.estadoComp.domain.screen.idCliente);
        // console.log("paso");
    };

    const footer = (
        <div>
            <Button
                label={"Seleccionar"}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    eliminarVentana(ventana);
                    ventana.notificarClienteSeleccionado({id:5});
                    eventoSynDom.stopPropagation();
                }}
                disabled={estadoQ.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label={"  Cancelar   "}
                icon="pi pi-times"
                onClick={(eventoSynDom) => {
                    eliminarVentana(ventana);
                    eventoSynDom.stopPropagation();
                }}
                disabled={estadoQ.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
                // className="w-32"
            />
            <Button
                label={"  Nuevo    "}
                icon="pi pi-file"
                onClick={(eventoSynDom) => {
                    dispatchQ(new BuscarClientes());
                    // buscarClientesCommand();
                    eventoSynDom.stopPropagation();
                }}
                loading={estadoQ.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
        </div>
    );

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Seleccionar Cliente</p>,
        enProgreso: estadoQ.flag.procesandoComando,
    };

    const dialogo = (
        <Dialogo
            // visible={true}
            // // style={{ width: "50vw"}}
            // modal={false}
            // onHide={() => onClick("CERRAR_DIALOGO")}
            // onShow={onShow}
            // onClick={() => onClick("CLICK_PANEL")}
            // keepInViewport={false}
            // maskStyle={{ zIndex: posicionZ }}
            ventana={ventana}
            cabecera={header}
            pie={footer}
            estilo={{ width: "80rem", minHeight: "70vh", top: "15vh", margin: "0" }}
            posicionZ={ventana.posicionZ}
            modal={false}
        >
            <DataTable
                value={estadoQ.data}
                paginator
                rows={8}
                showGridlines
                stripedRows
                size="small"
                selectionMode="single"
                // autoLayout={true}
                // autoLayout
                // autoLayout={false}
                // responsiveLayout="stack"
                // responsiveLayout="scroll"
                scrollable
                scrollDirection="both"
                emptyMessage="No se encontró Clientes a Facturar."
                totalRecords={100}
                // columnResizeMode="expand"
                columnResizeMode="fit"
                // resizableColumns
                tableStyle={{ minHeight: "40vh" }}
                onRowDoubleClick={dobleClickEnFila}
            >
                <Column
                    field="idCliente"
                    header="Id. Cliente"
                    style={{ width: "8%" }}
                    // bodyStyle={{ "width": "1%" }}
                    // unstyled
                ></Column>
                <Column
                    field="tipoCliente"
                    header="Tipo / Cliente"
                    style={{ width: "8%" }}
                ></Column>
                <Column field="nombres" header="Nombres" style={{ width: "15%" }}></Column>
                <Column field="apellidos" header="Apellidos" style={{ width: "15%" }}></Column>
                <Column field="tipoDoc" header="Tipo Doc." style={{ width: "10%" }}></Column>
                <Column field="nroDoc" header="Nro. Doc" style={{ width: "9%" }}></Column>
                {/* <Column field="dni" header="DNI" style={{ minWidth: "1rem" }}></Column>
                <Column field="ptp" header="PTP" style={{ minWidth: "1rem" }}></Column>
                <Column
                    field="carnetExt"
                    header="C. Extranjería"
                    style={{ minWidth: "1rem" }}
                ></Column>
                <Column field="pasaporte" header="Pasaporte" style={{ minWidth: "1rem" }}></Column> */}
                <Column field="ruc" header="Nro. RUC" style={{ width: "10%" }}></Column>
                <Column
                    field="razonSocial"
                    header="Razón Social"
                    style={{ width: "25%" }}
                    unstyled
                ></Column>
            </DataTable>
        </Dialogo>
    );

    return dialogo;
};

export default DialogoSeleccionarClienteLayout;
